<template>
    <div id="netgsm-detail">
        <div class="header">
            <div class="title">{{ $t("message.details") }}</div>
            <div class="subtitle">{{ $t("message.manageChannelDetail") }}</div>
        </div>
        <div id="new-sms-channel-form">
            <a-form>
                <div class="form-wrapper">
                    <div class="input-wrapper">
                        <label>{{ $t("whatsappChannel.channelName") }}</label>
                        <a-form-item :validate-status="getErrorStatus('name')" :help="getErrorMessage('name')">
                            <a-input
                                v-model="clone.name"
                                :placeholder="$t('whatsappChannel.channelName')"
                                name="name"
                                ref="name"
                            />
                        </a-form-item>
                    </div>
                    <div class="input-wrapper">
                        <label>{{ $t("message.username") }}</label>
                        <a-input
                            :placeholder="$t('message.username')"
                            v-model="clone.payload.username"
                            v-validate="'required'"
                            name="username"
                        />
                    </div>
                    <div class="input-wrapper">
                        <label>{{ $t("message.password") }}</label>
                        <a-input-password
                            :placeholder="$t('message.password')"
                            v-model="clone.payload.password"
                            v-validate="'required'"
                            name="password"
                        />
                    </div>
                    <div class="input-wrapper">
                        <label>{{ $t("message.defaultSender") }}</label>
                        <a-input
                            placeholder="SUPSIS"
                            v-model="clone.payload.defaultSender"
                            name="defaultSender"
                        />
                    </div>
                    <div class="input-wrapper">
                        <label>{{ $t("message.yourCredit") }}</label>
                        <a-input :value="String(credit)" disabled />
                    </div>
                </div>
            </a-form>

            <div class="form-footer">
                <div class="actions">
                    <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading">
                        {{ $t("message.save") }}</a-button
                    >
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from "vuex";
import _ from "lodash";

export default {
    name: "UpdateNetgsmDetails",
    props: {
        value: {
            type: Object,
            required: true,
        },
        credit: {
            type: [Number, String, Object],
            default: 0,
        },
    },
    data() {
        return {
            loading: false,
            clone: _.cloneDeep(this.value),
            submitClicked: false,
        };
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
        }),
        getErrorStatus(fieldName) {
            return this.clone[fieldName].length < 1 && this.submitClicked ? "error" : "";
        },
        getErrorMessage(fieldName) {
            return this.clone[fieldName].length < 1 && this.submitClicked ? this.$t("message.requiredChannel") : "";
        },
        handleSave() {
            this.submitClicked = true;
            if (this.clone.name.length < 1) {
                this.$refs.name.focus();
                return;
            }
            this.loading = true;
            this.updateChannel(this.clone)
                .then(() => {
                    this.$message.success(this.$t("message.channelUpdated"));
                    this.$emit("ok");
                })
                .catch(() => {
                    this.$message.error(this.$t("message.channelUpdateFailed"));
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    watch: {
        value: {
            handler(val) {
                if (!_.isEqual(val, this.clone)) {
                    this.clone = _.cloneDeep(val);
                }
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid var(--color-border-default);

    .title {
        font-size: 18px;
        font-weight: 700;
        color: var(--color-text-strong-default);
        padding-left: 5px;
    }

    .subtitle {
        font-size: 14px;
        color: var(--color-text-strong-default);
    }
}
#new-sms-channel-form {
    min-height: 250px;
    flex-direction: column;

    .form-wrapper {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;
        }
    }

    .form-footer {
        display: flex;
        justify-content: flex-end;
        padding: 10px;
        margin-top: 20px;
        background: var(--color-bg-default);
        border-top: 1px solid var(--color-border-default);
    }
}
</style>
